<ng-container>
    <mat-paginator [length]="pagination && pagination.count" [showFirstLastButtons]="showFirstLastButtons" [pageSize]="pageSize" [pageIndex]="pagination.pageIndex" [pageSizeOptions]="customPageSizeOptions ? pageSizeOptions2 : pageSizeOptions" (page)="setPageEvent($event)"> </mat-paginator>
</ng-container>
